module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/step4-pict02-55474275cdf25df011adb485c378857b.jpg";